<template>
  <div class="elective-score-edit">
    <el-dialog
      title="单个学生修改"
      :visible.sync="scoreEditShow"
      width="50%"
      :before-close="dialogClose"
      @open="dialogOpen"
    >
      <div class="btn-list">
        <!-- 学生：<span style="margin-right: 5px; font-weight: bold">张三</span> -->
        学生：
        <el-select
          v-model="scoreEditData.studentId"
          disabled
          placeholder="请选择"
        >
          <el-option
            v-for="item in gradeStudentList"
            :key="item.id"
            :label="item.studentName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <el-table
        :data="electiveFullList"
        border
        style="
          width: 600px;
          margin: 0 auto;
          max-height: 300px;
          overflow-y: auto;
        "
      >
        <!-- <el-table-column label="科目" prop="courseName"></el-table-column> -->
        <el-table-column label="科目">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.courseId"
              filterable
              disabled
              placeholder="请选择"
            >
              <el-option
                v-for="item in schoolCourseList"
                :key="item.id"
                :label="item.courseName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="学时" prop="hours"> </el-table-column>
        <el-table-column label="学分" prop="credit"> </el-table-column>
        <el-table-column label="评定等级">
          <template slot-scope="scope">
            <el-input v-model="scope.row.evaluationLevel"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-list">
        <el-button type="primary" @click="electiveScoreEditSubmit"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    "scoreEditShow",
    "scoreEditData",
    "schoolCourseList",
    "gradeStudentList",
  ],
  data() {
    return {
      electiveFullList: [],
    };
  },
  mounted() {
    this.electiveFullList[0] = this.scoreEditData;
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:scoreEditShow", false);
    },
    dialogOpen() {
      this.electiveFullList[0] = this.scoreEditData;
    },
    electiveScoreEditSubmit() {
      let data = {
        id: this.scoreEditData.id,
        evaluationLevel: this.electiveFullList[0].evaluationLevel,
      };
      this.$emit("editElectiveScore", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./electiveScoreEdit.scss";
</style>